<template>
  <article
    ref="element"
    :class="{ 'course-video': post.contentType === 'course_video' }"
  >
    <h2 v-if="title" :class="{ visible: readyTitle }" class="post-title">
      {{ title }}
    </h2>
    <div v-if="videoUrl" class="video-container">
      <video controls>
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </div>

    <HtmlPostContent
      :content="content"
      :class="{ visible: readyContent }"
      class="content"
    />
  </article>
</template>
<script lang="ts" setup>
import type { MediaSchema, PostSchema } from '~/types/schema';
interface Props {
  title?: string;
  post: PostSchema;
  mMedias?: Map<string, MediaSchema>;
}
const element = ref(null);

const props = defineProps({
  title: null,
  post: null,
  mMedias: null
});

const content = computed(() => props.post?.content ?? '');

const readyContent = ref<boolean>(false);
const readyTitle = ref<boolean>(false);

const mediaId = computed(() =>
  props.post?.medias?.length ? props.post.medias[0] : null
);

const videoUrl = computed(() => {
  if (!mediaId?.value?.id) return null;
  if (mediaId.value && props.mMedias.has(mediaId.value.id)) {
    const mediaInfos = props.mMedias.get(mediaId.value.id);
    if (mediaInfos.type === 'video') return mediaInfos.url;
  }
  return null;
});

const handleRenderComplete = () => {
  readyContent.value = true;
};

useMathJax(element, handleRenderComplete);

onMounted(async () => {
  setTimeout(() => {
    readyTitle.value = true;
  }, 20);
});
</script>
<style lang="scss" scoped>
h2 {
  margin: 2rem 0 5rem;
  transition: opacity 800ms $ease-out-quad;
  opacity: 0;

  --font_size: var(--text_size_xl);
  --line_height: var(--text_lh_xl);

  text-align: center;
  &::after {
    content: '';
    display: block;
    width: 60%;
    height: 0.1rem;
    margin: 2rem auto 3rem;
    transform: scaleX(0.5);
    transition: transform 800ms $ease-out-quad 200ms,
      opacity 800ms $ease-out-quad 200ms;
    opacity: 0;
    background: linear-gradient(
      90deg,
      rgb(242 236 232 / 0%) 0%,
      rgb(242 236 232 / 100%) 20%,
      rgb(242 236 232 / 100%) 50%,
      rgb(242 236 232 / 100%) 80%,
      rgb(242 236 232 / 0%) 100%
    );
  }
  &.visible {
    opacity: 1;
    &::after {
      transform: scaleX(1);
      opacity: 1;
    }
  }
}
.content {
  padding: 0;
  transform: scale(0.95);
  transition: opacity 200ms $ease-out-quad, transform 200ms $ease-out-back;
  opacity: 0;
  &.visible {
    transform: scale(1);
    opacity: 1;
  }
}

.course-video {
  h2 {
    margin: 1rem 0;
    &::after {
      display: none;
    }
  }
}

.video-container {
  display: flex;
  align-items: center;
  justify-content: center;
  video {
    height: 60vh;
    height: 60dvh;
  }
}
</style>
